<h2 mat-dialog-title>Vincular novo especialista</h2>
<mat-dialog-content class="mat-typography">
  <p>Veja abaixo os especialistas disponíveis, clique na foto para ver mais detalhes, se preferir, realize sua busca no campo abaixo:</p>
  <div class="row">
    <div class="col-xs-12 col-md-9 col-lg-10">
      <mat-form-field class="example-full-width" appearance="outline">
        <mat-label>Faça sua busca pelo especialista, especialidade ou cidade</mat-label>
        <input
          type="text"
          matInput
          [(ngModel)]="search"
          [ngModelOptions]="{ standalone: true }"
          placeholder="Digite aqui sua busca pelo especialista, especialidade ou cidade"
        />
      </mat-form-field>
    </div>
  </div>
  <div class="row">
    <div class="col-xs-12 col-lg-6" *ngFor="let practitioner of practitionersFilter">
      <mat-card>
        <!-- <div class="col-xs-5 col-md-3">
                    <page-avatar [gender]="practitioner.gender" [avatar]="practitioner.avatar"
                    (click)="openDetails(practitioner)"></page-avatar>
                </div> -->
        <div class="col-xs-12 col-md-12">
          <div class="content">
            {{ practitioner.name }} <br />
            {{ getSpecialization(practitioner) }} <br />
            {{ getCity(practitioner) }} <br />
            <button mat-stroked-button [disabled]="practitioner.isHidden" color="primary" (click)="linkWithSecretary(practitioner)">Vincular</button>
          </div>
        </div>
      </mat-card>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button color="primary" [mat-dialog-close]="refreshMainComponent">Fechar</button>
</mat-dialog-actions>
